import { TweenMax, Linear } from 'gsap';
import { $ } from 'utils';

const ease = Linear.easeNone;

const mapDirections = {
  left: '+',
  right: '-',
  down: '+',
  up: '-'
};

export default ({
  className,
  direction,
  distance,
  duration
}) => {
  const elem = $(`.${className}`);

  if (!elem) {
    return null;
  }

  const axis = direction === 'down' || direction === 'up' ? 'y' : 'x';

  return TweenMax.from(elem, duration || 1, {
    [`${axis}Percent`]: `${mapDirections[direction]}${distance || '100'}`,
    ease
  });
};



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/scroll-animations/move.js